var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn inline-block",attrs:{"href":_vm.link}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }